import {SingletonService} from '@/common/dependency.configs'
import HttpHandler from '@/common/services/connect/HttpHandler'
import {inject, injectable} from 'inversify'
import type RestResponse from '@/common/data/RestResponse'

@SingletonService
@injectable()
class EmployeeChannelWorkflowGroupsFactory {
  constructor(
    @inject(HttpHandler)
    private httpHandler: HttpHandler
  ) {}

  getAll(): Promise<RestResponse<Array<EmployeeChannelWorkflowGroup>>> {
    return this.httpHandler.get(
      `{{boltsui}}/employee-channel-workflow-groups`
    )
  }

  get(
    workflowGroupId: string
  ): Promise<RestResponse<EmployeeChannelWorkflowGroup>> {
    return this.httpHandler.get(
      `{{boltsui}}/employee-channel-workflow-groups/${workflowGroupId}`
    )
  }

  create(
    dto: EmployeeChannelWorkflowGroup
  ): Promise<RestResponse<EmployeeChannelWorkflowGroup>> {
    return this.httpHandler.post(
      `{{boltsui}}/employee-channel-workflow-groups`,
      dto
    )
  }

  update(
    workflowGroupId: string,
    dto: EmployeeChannelWorkflowGroup
  ): Promise<RestResponse<EmployeeChannelWorkflowGroup>> {
    return this.httpHandler.put(
      `{{boltsui}}/employee-channel-workflow-groups/${workflowGroupId}`,
      dto
    )
  }
}

export type EmployeeChannelWorkflowGroupType = 'PERSON' | 'BUSINESS'

export type EmployeeChannelWorkflowGroup = {
  workflowGroupId?: string
  applicantWorkflow?: string
  enrollmentWorkflow?: string
  businessRepresentativeWorkflow?: string
  applicantChannelWorkflow?: string | null
  workflowGroupName: string
  workflowGroupType: EmployeeChannelWorkflowGroupType
  enabled: boolean
}

export default EmployeeChannelWorkflowGroupsFactory
